import { DateTime } from 'luxon';
import React from 'react';
import { AppHeader } from '../../../components/common';
import CardClassTrainer from '../../../components/common/CardClassTrainer';
import { handleWebBrowser } from '../../../config/utils';

const ClassesByTenant = ({ navigation, route }) => {
  const dataClasses = route.params;

  const getClassText = ({ rated, data, horario_fim }) => {
    const today = DateTime.now().minus({ hours: 3 });
    if (rated) {
      return 'Finalizada';
    }
    if (today.toFormat('yyyy-LL-dd') >= data.substring(0, 10)) {
      if (horario_fim <= today.toFormat('HH:mm')) {
        return 'Finalizada';
      }
      if (today.toFormat('yyyy-LL-dd') === data.substring(0, 10)) {
        return 'Aula';
      }
      return 'Finalizada';
    }
    return 'Reagendar';
  };

  const handleAccessButton = (rated, data, link_reuniao, horario_fim, id_aula) => {
    if (!rated) {
      switch (getClassText({ rated, data, horario_fim })) {
        case 'Aula':
          handleWebBrowser(link_reuniao);
          break;
        case 'Reagendar':
          navigation.navigate('Class Re-Schedule', { id_aula });
          break;
        default: break;
      }
    }
  };

  return (
    <>
      <AppHeader navigation={navigation} hasBack title={dataClasses.name} />
      {dataClasses.type === 'EMPRESA' ? (
        <>
          {dataClasses.classes.map(({
            id_aula, data, horario_inicio, rated, horario_fim, link_reuniao, nome_empresa, cd_tipo,
          }) => (
            <CardClassTrainer
              key={id_aula}
              data={{
                id_aula,
                cd_tipo,
                name: nome_empresa,
                link: link_reuniao,
                date: data,
                horario: horario_inicio,
                fim: horario_fim,
                isWorker: true,
                textButton: getClassText({ rated, data, horario_fim }),
                handleButton: () => handleAccessButton(rated, data, link_reuniao, horario_fim, id_aula),
              }}
            />
          ))}
        </>
      ) : (
        <>
          {dataClasses.classes.map(({
            date, horario, link, nome,
          }, index) => (
            <CardClassTrainer
              key={index}
              data={{

                name: nome,
                link,
                date,
                horario,
                isWorker: false,
                disabled: !link,
                textButton: !link ? 'Aguarde' : 'Acessar',
                handleButton: () => handleWebBrowser(link),
              }}
            />
          ))}
        </>
      )}
    </>
  );
};

export default ClassesByTenant;
